import Api from "../Api/Api";

// List all custom dynamic events (9+)
export const listCustomEventTypes = () => {
    return Api.get('admin/dynamic/dynamicEvents');
};

// Create new custom dynamic event
export const createEventType = (data) => {
    // If data is FormData, let axios handle Content-Type automatically
    // Otherwise, send as JSON
    const config = data instanceof FormData 
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : { headers: { 'Content-Type': 'application/json' } };
    return Api.post('admin/dynamic/dynamicEvents', data, config);
};

// Update existing custom dynamic event (ID must be >= 9)
export const updateEventType = (id, data) => {
    // If data is FormData, let axios handle Content-Type automatically
    // Otherwise, send as JSON
    const config = data instanceof FormData 
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : { headers: { 'Content-Type': 'application/json' } };
    return Api.put(`admin/dynamic/dynamicEvents/${id}`, data, config);
};

// Delete custom dynamic event (ID must be >= 9)
export const deleteEventType = (id) => {
    return Api.delete(`admin/dynamic/dynamicEvents/${id}`);
};

// Get recommended questions for a custom dynamic event
export const getEventTypeQuestions = (eventTypeId) => {
    return Api.get(`admin/dynamic/dynamicEvents/${eventTypeId}/questions`);
};

// Add recommended question to custom dynamic event
export const addEventTypeQuestion = (eventTypeId, data) => {
    return Api.post(`admin/dynamic/dynamicEvents/${eventTypeId}/questions`, data);
};

// Update recommended question
export const updateEventTypeQuestion = (eventTypeId, questionId, data) => {
    return Api.put(`admin/dynamic/dynamicEvents/${eventTypeId}/questions/${questionId}`, data);
};

// Delete recommended question
export const deleteEventTypeQuestion = (eventTypeId, questionId) => {
    return Api.delete(`admin/dynamic/dynamicEvents/${eventTypeId}/questions/${questionId}`);
};
